import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { find as _find, filter as _filter } from 'lodash';

import List from 'components/List';
import RichEditorContent from 'components/RichEditorContent';
import ModalTeamMembers from 'components/modals/ModalTeamMembers';

class ClientTeams extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showMembers: false,
      showMembersTeamId: null,
    };
  }

  showMembers = (e, showMembersTeamId) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showMembers: true, showMembersTeamId });
  };

  closeMembers = () => {
    this.setState({ showMembers: false });
  };

  isChecked = team => {
    const { entity } = this.props;
    return _find(entity.getTeams(), ['id', team.id]) !== undefined;
  };

  checkDisabled = () => {
    const { disabled } = this.props;
    if (disabled) {
      return true;
    }
    return false;
  };

  onChange = e => {
    const { target } = e;
    const teamId = target.value;
    const { checked } = target;

    const { entity, changeEntity } = this.props;
    let newValue;
    if (checked) {
      newValue = entity.getTeams().slice();
      newValue.push(entity.createValue('teams', [], this.getTeam(teamId)));
    } else {
      newValue = _filter(entity.getTeams(), t => {
        return t.getId() !== teamId;
      });
    }

    const newEntity = { ...entity.updateValue('teams', newValue, []) };

    changeEntity(newEntity);
  };

  getTeam = teamId => {
    const { teams } = this.props;
    return _find(teams.data.list, ['id', teamId]);
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      teams,
      inModal,
    } = this.props;
    const { showMembers, showMembersTeamId } = this.state;

    return (
      <div className="clearfix">
        <List listName="teams" url="/api/teams.json">
          {entityLoaded && (
            <Row>
              <Col xs={12} md={inModal ? 12 : 4}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p>
                      {messages.formGroup.user_teams}
                      {teams.pending && <i className="m-l-10 fa fa-circle-notch fa-spin" />}
                    </p>
                    <div>
                      {teams.data.list.map((team, i) => {
                        if (!team.is_hidden){
                          return (
                            <div className="m-b-20" key={team.id}>
                              <div className="checkbox check-success m-b-0">
                                <input
                                  disabled={this.checkDisabled()}
                                  id={'clientTeam' + i}
                                  name="teams[]"
                                  type="checkbox"
                                  value={team.id}
                                  checked={this.isChecked(team)}
                                  onChange={this.onChange}
                                />
                                <label for={'clientTeam' + i}>
                                  {team.name}
                                  {!!team.type && (
                                    <span className="m-l-15">
                                      ({messages.system_type}: {team.type_name})
                                    </span>
                                  )}
                                </label>
                              </div>

                              <div className="p-l-25">
                                {!!team.description && (
                                  <p className="hint-text fs-13">
                                    <RichEditorContent content={'<div>' + team.description + '</div>'} />
                                  </p>
                                )}

                                <div>
                                  <a href="#members" onClick={e => this.showMembers(e, team.id)}>
                                    {messages.team_members}
                                  </a>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              </Col>

              <ModalTeamMembers show={showMembers} close={this.closeMembers} teamId={showMembersTeamId} />
            </Row>
          )}
        </List>
      </div>
    );
  }
}
ClientTeams.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    teams: state.list.teams,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientTeams));
